import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../iconify';

LogTemplate.propTypes = {
  icon: PropTypes.string,
  message: PropTypes.object,
  idx: PropTypes.number,
}
export default function LogTemplate({ icon, message, idx }) {

  const setLineHeight = () => {
    const container = document.querySelector('.logContainer');
    const line = document.querySelector('.logLine');
    if (line !== null) {
      line.style.height = `${container.scrollHeight}px`;
    }
  };

  window.addEventListener('load', setLineHeight);
  window.addEventListener('resize', setLineHeight);
  setTimeout(setLineHeight, 100);

  return (
    <Box
      sx={{
        zIndex: 5,
        position: 'relative',
        maxWidth: '95%',
        overflowWrap: 'normal',
        marginTop: idx === 0 ? '15px' : '40px',
        maxHeight: '100%',
      }}
    >
      <div
        style={{
          width: '5px',
          height: '1px',
          backgroundColor: '#208ee078',
          position: 'absolute',
          top: '10px',
          left: '15px',
        }}
      >
        {' '}
      </div>
      <Box
        sx={{
          position: 'absolute',
          top: '-5px',
          left: '20px',
          backgroundColor: 'white',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
          padding: '5px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Iconify icon={icon} color="info" height="18px" width="18px" />
      </Box>
      <Box
        sx={{
          fontSize: '14px',
          wordBreak: 'normal',
          marginLeft: '35px',
          zIndex: '0',
          display: 'relative',
          paddingLeft: '25px',
        }}
      >
        {message}
      </Box>
    </Box>
  );
}